<script>


export default {
  translate25Context: 'troubleshooting',
  methods: {},
  props: ["handler", "instance"],
  data() {
    return {
    };
  },
  methods: {

  },
  async mounted() {
  },
  watch: {}
};
</script>

<template>
  <div class="troubleshooting-player">
    <troubleshooting-page :title="$vt('Player prerequises')">
      <template #content>

        <div class="list">
          <div class="title">{{ $vt('Domains') }}</div>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_player:api'].component.app"></troubleshooting-page-http-status>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_player:api'].component.player"></troubleshooting-page-http-status>

          <troubleshooting-page-websocket-status
            :component="instance['troubleshooting_player:api'].component.vruncache"></troubleshooting-page-websocket-status>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_player:api'].component.akamai"></troubleshooting-page-http-status>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_player:api'].component.vodcache"></troubleshooting-page-http-status>
 

        </div>

        <div class="bandwith list">
          <div class="title">{{ $vt('Network requirement') }}</div>
          <troubleshooting-bandwith2
            :component="instance['troubleshooting_player:api'].component.bandwith"></troubleshooting-bandwith2>
        </div>

        <div class="list">
          <div class="title">{{ $vt('Browser') }}</div>
          <troubleshooting-page-platform></troubleshooting-page-platform>
        </div>

      </template> 
    </troubleshooting-page>
  </div>
</template>

<style lang="scss">
.troubleshooting-player {
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>